import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { motion } from 'framer-motion';

export function ProductCard({ product }) {
  const { addToCart } = useCart();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className="aspect-square overflow-hidden rounded-lg bg-[#141414] mb-4 border border-[#2A2520] group-hover:border-[#C4A35A]/30 transition-all">
          {product.images && product.images[0] ? (
            <img
              src={product.images[0]}
              alt={product.name}
              className="w-full h-full object-cover cc-product-image"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#2A2520]">
              <span className="text-4xl font-['Cormorant_Garamond'] text-[#C4A35A]/30">CC</span>
            </div>
          )}
        </div>
      </Link>

      <div className="space-y-1.5">
        <Link to={`/product/${product.id}`}>
          <h3 className="text-sm font-medium text-[#F0E6D0] group-hover:text-[#C4A35A] transition-colors leading-snug" data-testid={`product-name-${product.id}`}>
            {product.name}
          </h3>
        </Link>

        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-[#C4A35A]" data-testid={`product-price-${product.id}`}>
            ${product.price.toFixed(2)}
          </p>

          {product.in_stock ? (
            <button
              onClick={(e) => { e.preventDefault(); addToCart(product.id); }}
              className="text-xs px-4 py-1.5 rounded-full bg-[#C4A35A] text-[#0A0A0A] font-medium hover:bg-[#D4B86A] transition-all duration-300 hover:-translate-y-0.5"
              data-testid={`add-to-cart-${product.id}`}
            >
              Add to Bag
            </button>
          ) : (
            <span className="text-xs px-3 py-1.5 rounded-full bg-[#1E1E1E] text-[#9A8E7A] border border-[#2A2520]" data-testid={`sold-out-${product.id}`}>
              Sold Out
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
}
